import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MobileSidebar.scss';

const MobileSidebar = ({ isOpen, onClose }) => {
    const location = useLocation();

    const handleLinkClick = (e, path) => {
        if (location.pathname === path) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        onClose();
    };

    return (
        <>
            <div 
                className={`sidebar-overlay ${isOpen ? 'active' : ''}`} 
                onClick={onClose}
            ></div>
            <div className={`sidebar ${isOpen ? 'active' : ''}`}>
                <div className="sidebar-header">
                    <button 
                        className="sidebar-close" 
                        onClick={onClose}
                        aria-label="Close menu"
                    >
                        ×
                    </button>
                </div>
                <ul className="sidebar-links">
                    <li><Link to="/" onClick={(e) => handleLinkClick(e, '/')}>Home</Link></li>
                    <li><Link to="/services" onClick={(e) => handleLinkClick(e, '/services')}>Services</Link></li>
                    <li><Link to="/about" onClick={(e) => handleLinkClick(e, '/about')}>About</Link></li>
                    <li><Link to="/conditions" onClick={(e) => handleLinkClick(e, '/conditions')}>Conditions</Link></li>
                    <li><Link to="/contact" onClick={(e) => handleLinkClick(e, '/contact')}>Contact</Link></li>
                </ul>
            </div>
        </>
    );
};

export default MobileSidebar;

